"use client";

import React from "react";
import { ShieldCheck, TriangleAlert, CircleCheck, CircleX } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const officialFeatures = [{
  id: "off-1",
  text: "企业级融资额度，最高可达 $250,000+"
}, {
  id: "off-2",
  text: "不计入个人负债率，保护个人信用评分"
}, {
  id: "off-3",
  text: "享受 0% 初始利率，大幅降低融资成本"
}, {
  id: "off-4",
  text: "建立企业信用档案，为未来扩张奠定基础"
}];
const otherRisks = [{
  id: "oth-1",
  text: "额度受个人收入限制，通常低于 $50,000"
}, {
  id: "oth-2",
  text: "高额负债直接影响个人房贷与车贷申请"
}, {
  id: "oth-3",
  text: "利率波动较大，缺乏企业专属金融优惠"
}, {
  id: "oth-4",
  text: "个人资产与业务风险绑定，缺乏法律防火墙"
}];
export default function OfficialVsOtherChannels() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254555" id="credit-vs-capital" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">
            企业资本 vs. 个人信用
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            了解两者之间的核心差异，选择最适合您业务扩张的金融杠杆。
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <Card className="relative border-primary/30 shadow-2xl shadow-primary/10 bg-card/60 backdrop-blur-md overflow-hidden group">
            <div className="absolute inset-0 bg-gradient-to-b from-primary/10 to-transparent pointer-events-none" />
            <CardHeader className="pb-8 pt-10 text-center relative z-10">
              <div className="mx-auto mb-6 bg-primary/20 w-20 h-20 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-primary/20">
                <ShieldCheck className="w-10 h-10 text-primary" />
              </div>
              <CardTitle className="text-2xl font-bold font-default text-foreground uppercase tracking-wider">
                企业资本 (Business Capital)
              </CardTitle>
            </CardHeader>
            <CardContent className="relative z-10 px-8 pb-12">
              <ul className="space-y-6">
                {officialFeatures.map((feature, i) => <li key={feature.id} data-index={i} className="flex items-start gap-4">
                    <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                    <span className="text-foreground text-lg leading-relaxed font-default">
                      {feature.text}
                    </span>
                  </li>)}
              </ul>
            </CardContent>
          </Card>

          {}
          <Card className="border-border bg-muted/20 backdrop-blur-sm shadow-lg overflow-hidden">
            <CardHeader className="pb-8 pt-10 text-center">
              <div className="mx-auto mb-6 bg-destructive/10 w-20 h-20 rounded-lg flex items-center justify-center">
                <TriangleAlert className="w-10 h-10 text-destructive" />
              </div>
              <CardTitle className="text-2xl font-bold font-default text-foreground uppercase tracking-wider">
                个人信用 (Personal Credit)
              </CardTitle>
            </CardHeader>
            <CardContent className="px-8 pb-12">
              <ul className="space-y-6">
                {otherRisks.map((risk, i) => <li key={risk.id} data-index={i} className="flex items-start gap-4">
                    <CircleX className="w-6 h-6 text-destructive shrink-0 mt-0.5" />
                    <span className="text-muted-foreground text-lg leading-relaxed font-default">
                      {risk.text}
                    </span>
                  </li>)}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}